<script>

    import { toast } from 'bulma-toast'

    import { packagesStore, modalStore } from '../stores'
    import PackagesService from '../$services/packages.service'

    import Spinner from '../$components/spinner.svelte'

    let data = {}
    let loading = false

    async function createPackage() {

        loading = true
        const resp = await PackagesService.createPackage(data)
        loading = false

        if(!resp.success)
            return toast({message: resp.error.message, type: 'is-danger'})

        packagesStore.append(resp.data)
        toast({message: 'Paquete creado', type: 'is-success'})
        modalStore.close()
    }

</script>

<Spinner {loading} />

{#if !loading}
    <form on:submit|preventDefault={createPackage}>
        <div class="columns">
            <div class="column">
                <div class="field">
                    <label for="" class="label">Alias</label>
                    <div class="control has-icons-left">
                        <span class="icon"><i class="fas fa-address-book"></i></span>
                        <input bind:value={data.alias} type="text" class="input" placeholder="Identificador del paquete" required>
                    </div>
                </div>
            </div>
        </div>
        <div class="columns">
            <div class="column">
                <div class="field">
                    <label for="" class="label">Ancho</label>
                    <div class="control has-icons-left">
                        <span class="icon"><i class="fas fa-ruler-horizontal"></i></span>
                        <input bind:value={data.width} type="number"  min="1" class="input" placeholder="Ancho, medida en cm" required>
                    </div>
                </div>
            </div>
            <div class="column">
                <div class="field">
                    <label for="" class="label">Alto</label>
                    <div class="control has-icons-left">
                        <span class="icon"><i class="fas fa-ruler-vertical"></i></span>
                        <input bind:value={data.height} type="number" min="1"  class="input" placeholder="Alto, medida en cm" required>
                    </div>
                </div>
            </div>
        </div>
        <div class="columns">
            <div class="column">
                <div class="field">
                    <label for="" class="label">Largo</label>
                    <div class="control has-icons-left">
                        <span class="icon"><i class="fas fa-ruler"></i></span>
                        <input bind:value={data.length} type="number" min="1"  class="input" placeholder="Largo, medida en cm" required>
                    </div>
                </div>
            </div>
            <div class="column">
                <div class="field">
                    <label for="" class="label">Peso</label>
                    <div class="control has-icons-left">
                        <span class="icon"><i class="fas fa-weight"></i></span>
                        <input bind:value={data.weight} type="number" min="1"  class="input" placeholder="Peso en kg" required>
                    </div>
                </div>
            </div>
        </div>
        <div class="columns">
            <div class="column">
                <div class="field">
                    <label for="" class="label">Contenido</label>
                    <div class="control has-icons-left">
                        <span class="icon"><i class="fas fa-asterisk"></i></span>
                        <input bind:value={data.content} type="text" min="20" class="input" placeholder="Contenido, o descripción del paquete" required>
                    </div>
                </div>
            </div>
            <div class="column">
                <div class="field">
                    <label for="" class="label">Asegurar envío</label>
                    <div class="control has-icons-left">
                        <span class="icon"><i class="fas fa-dollar-sign"></i></span>
                        <input bind:value={data.value} type="number" min="0" class="input" placeholder="Valor declarado" required>
                    </div>
                </div>
            </div>
        </div>

        <div class="items-end">
            <button on:click={() => modalStore.close() } type="button" class="button space-right">
                <span class="icon"><i class="fas fa-ban"></i></span>
                <span>Cancelar</span>
            </button>
            <button type="submit" class="button is-primary">
                <span class="icon"><i class="fas fa-save"></i></span>
                <span>Guardar</span>
            </button>
        </div>
    </form>
{/if}